export default __webpack_public_path__ + "static/media/discounts-family15-image.e7321dd7.svg";